// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import styled from 'styled-components'

import {
  Carousel,
  CarouselItem,
  Col,
} from 'reactstrap'

export const CarouselWrapper = styled(Carousel)`
  // lg size in bootstrap
  @media (min-width: 1200px) {
    font-size: .9rem;
  }

  // lg size in bootstrap
  @media (max-width: 1200px) {
    font-size: .8rem;
  }

  @media (max-height: 700px) {
    font-size: .7rem;
  }

  .carousel-control-prev, .carousel-control-next {
    display: none;
  }

  &:hover {
    .carousel-control-prev, .carousel-control-next {
      display: flex;
    }
  }
`

export const CarouselItemWrapper = styled(CarouselItem)`
  @media (min-height: 700px) {
    font-size: .8rem;
    min-height: 130px;
  }

  @media (max-height: 700px) {
    font-size: .6rem;
    min-height: 80px;
  }

  background: rgb(236,28,36);
  background: linear-gradient(90deg, rgba(236,28,36,1) 0%, rgba(255,199,18,1) 100%);
  color: #fff;
  max-width: 100%;
  text-align: center;
`

export const CaptionHeading = styled.div`
  align-self: center;
  display: flex;
  flex-direction: column;
  padding-left: 1em;
  text-align: center;
  white-space: nowrap;

  // md size in bootstrap
  @media (max-width: 992px) {
    position: relative;
    text-shadow: 0 0 .125em #000;
    white-space: initial;
    z-index: 2;

    + img {
      margin-left: -20em;
      margin-right: 7em;
      opacity: 0.6;
      z-index: 1;
    }
  }

  > strong {
    font-size: 1.5em;
  }

  > span {
    font-size: 1.25em;
  }
`

export const CaptionItemWrapper = styled.div`
  align-items: center;
  display: flex;

  // ~~lg size in bootstrap
  @media (max-width: 1250px) {
    width: 50%;
  }

  // md size in bootstrap
  @media (max-width: 992px) {
    font-size: .7em;
  }

  // sm size in bootstrap
  @media (max-width: 768px) {
    font-size: .7em;
    width: 100%;
  }

  & {
    padding-left: .5em;
  }

  > strong {
    font-size: 2.5em;
  }

  > span {
    font-size: 1em;
    font-weight: 100;
    line-height: 1;
    padding-left: .25em;
    text-align: left;
  }
`

export const ItemCountWrapper = styled.div`
  display: flex;
  justify-content: around;
  flex: 1;

  // lg size in bootstrap
  @media (max-width: 1200px) {
    flex-wrap: wrap;
  }
`

export const CaptionImage = styled.img`
  @media (min-height: 700px) {
    height: 130px;
  }

  @media (max-height: 700px) {
    height: 80px;
  }
`
